module.exports = __webpack_public_path__ + "img/video_zhlj_01.c7c64ea8.jpg";